import React, { Component } from 'react'
import { app } from '../config/base'

class Logout extends Component {

  constructor() {
    super()
    this.state = {
      redirect: false
    }
  }

  componentWillMount() {
    app.auth().signOut().then((user) => {
      window.location.replace('/')
    })
  }

  render() {


    return (
      <div style={{ textAlign: "center", position: "absolute", top: "25%", left: "50%" }}>
        <h3>Logging Out</h3>
        <i className="fa fa-circle-o-notch"></i>
      </div>
    )
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/components/Logout.js